import React from 'react';
import { Message, Button, Icon } from 'semantic-ui-react';
import { useBluetooth } from '../../contexts/BluetoothContext';

interface BluetoothDisconnectionNotificationProps {
  isVisible: boolean;
  onDismiss: () => void;
}

const BluetoothDisconnectionNotification: React.FC<BluetoothDisconnectionNotificationProps> = ({
  isVisible,
  onDismiss
}) => {
  const { connect, isConnecting } = useBluetooth();

  const handleReconnect = async () => {
    try {
      await connect();
      onDismiss();
    } catch (error) {
      console.error('Failed to reconnect Bluetooth:', error);
    }
  };

  if (!isVisible) return null;

  return (
    <div className="bluetooth-disconnection-notification">
      <Message
        negative
        icon
        size="large"
        style={{
          position: 'fixed',
          top: '20px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 1000,
          maxWidth: '500px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
        }}
      >
        <Icon name="bluetooth" />
        <Message.Content>
          <Message.Header>Bluetooth Device Disconnected</Message.Header>
          <p>
            Your Bluetooth device has been disconnected. The workout has been paused.
            Please reconnect your device to continue.
          </p>
          <div style={{ marginTop: '10px' }}>
            <Button
              primary
              loading={isConnecting}
              disabled={isConnecting}
              onClick={handleReconnect}
              style={{ marginRight: '10px' }}
            >
              <Icon name="bluetooth" />
              {isConnecting ? 'Connecting...' : 'Reconnect Device'}
            </Button>
            <Button onClick={onDismiss}>
              Dismiss
            </Button>
          </div>
        </Message.Content>
      </Message>
    </div>
  );
};

export default BluetoothDisconnectionNotification;
